export default {
  name: 'Content section - 15',
  tab: 'content',
  type: 'content-side-by-syde-section',
  content: {
    title: '',
    introtext: '',
    image: '/storage/media/samples/chris-abney-qLW70Aoo8BE-unsplash.jpg',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '20px',
    'padding-bottom': '20px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-vertical-alignment': 'center',
    'image-size': 'lg',
    'image-position': 'left',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0',
    'content-box-border-color': 'inherit'
  },
  advanced: {}
}
